// Scroll guard: a closed Google vignette ad can leave the page scroll-locked
// (inline overflow:hidden on <html>/<body>). This module restores scrolling
// once no vignette is on screen. It lives in the shared bundle so every page
// gets it from one place.

/** Tell whether a Google vignette ad is currently covering the viewport. */
function isVignetteOpen() {
  const frames = document.querySelectorAll("iframe");
  for (const frame of frames) {
    const rect = frame.getBoundingClientRect();
    if (rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9) return true;
  }
  return false;
}

/** Clear a leftover inline scroll lock, unless a modal or a vignette is open. */
function unlockScroll() {
  if (document.querySelector(".modal.show")) return;
  if (isVignetteOpen()) return;
  const root = document.documentElement;
  const body = document.body;
  if (root && root.style.overflow === "hidden") root.style.overflow = "";
  if (body && body.style.overflow === "hidden") body.style.overflow = "";
}

/** Install the scroll guard: react to hash changes and re-check every second. */
export function install() {
  window.addEventListener("hashchange", () => setTimeout(unlockScroll, 100));
  setInterval(unlockScroll, 1000);
}
